export const mockData = {
  car: [
    {
      carNumber: '38무0874',
      carName: '아반떼 CN7',
      carYear: '2022년식',
      carScale: '승용',
      carRegion: '서울',
      carReservationDate: [
        "2025-01-10T09:30:00+09:00",
        "2025-01-25T13:00:00+09:00"
      ],
      carRepairPart: ['본네트', '범퍼(전)', '라디에이터'],
      userName: '박서준',
      userPhoneNumber: '010-9876-5432',
      userRequest: '출고 전 꼼꼼한 점검 부탁드립니다.'
    },
    {
      carNumber: '10버0834',
      carName: '그랜저 XG',
      carYear: '1999년식',
      carScale: '승용',
      carRegion: '',
      carReservationDate: [
        "2025-01-04T11:00:00+09:00",
        "2025-01-20T14:00:00+09:00"
      ],
      carRepairPart: ['앞펜더(우)', 'A필러(우)', '뒷문(우)', '뒤펜더(우)'],
      userName: '김윤진',
      userPhoneNumber: '010-1234-4567',
      userRequest: ''
    },
    {
      carNumber: '52라9921',
      carName: '싼타페 TM',
      carYear: '2021년식',
      carScale: 'SUV',
      carRegion: '경기',
      carReservationDate: [
        "2025-01-15T10:00:00+09:00",
        "2025-01-30T15:30:00+09:00"
      ],
      carRepairPart: ['도어(좌)', '사이드미러(좌)', '휀더(좌)'],
      userName: '이지민',
      userPhoneNumber: '010-5555-7777',
      userRequest: '급한 수리가 필요합니다.'
    }
  ]
};